/**
 * Centralized icon map for navigation.
 * Maps icon string identifiers to their corresponding SVG asset paths.
 * Icons are served as static files from the public/icons directory and
 * rendered via NavIconImage (see NavAccordion, NavDirectLink, NavHomeButton).
 *
 * TODO: profile, rxLite, and lists don't have dedicated SVGs yet — they
 * currently fall back to the generic miscellaneous icon.
 */
export const navIconMap: Record<string, string> = {
  home: '/icons/home.svg',
  eligibility: '/icons/eligibility.svg',
  profile: '/icons/profile.svg',
  operations: '/icons/operations.svg',
  provider: '/icons/providers.svg',
  dur: '/icons/dur.svg',
  pricing: '/icons/pricing.svg',
  plan: '/icons/plan.svg',
  manualclaim: '/icons/manual-claims.svg',
  rxLite: '/icons/rxclaim-lite.svg',
  presto: '/icons/rxclaim.svg',
  patientpay: '/icons/patient-pay.svg',
  accumulators: '/icons/accumulators.svg',
  savingsaccounts: '/icons/savings-account.svg',
  product: '/icons/product.svg',
  lists: '/icons/lists.svg',
  miscellaneous: '/icons/miscellaneous.svg',
};

/**
 * Default icon path to use when an icon key is not found in the map.
 */
export const defaultNavIcon = '/icons/miscellaneous.svg';
